import { CheckBadgeIcon, CpuChipIcon } from "@heroicons/react/24/solid";
import React from "react";
import { skills } from "../data/data";

export default function Skills() {
    return (
        <section id="skills">
            <div className="container px-5 py-10 mx-auto">
                <div className="text-center mb-20">
                    <CpuChipIcon className="w-10 inline-block mb-4" />
                    <h1 className="sm:text-4xl text-3xl font-medium title-font dark:text-white mb-4">
                        Skills &amp; Technologies
                    </h1>
                    <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                        A list of skills and technologies that are most recent to mind. However, I'm very capable of adapting to other languages or technologies.
                    </p>
                </div>
                <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
                    {skills.map((skill) => (
                        <div key={skill} className="p-2 sm:w-1/2 w-full">
                            <div className="bg-sky-100 dark:bg-gray-800 rounded flex p-4 h-full">
                                <CheckBadgeIcon className="text-green-400 w-6 h-6 flex-shrink-0" />
                                <span className="font-medium dark:text-white flex-grow text-center">{skill}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}